export default "<p>\r\n  dialog-producto works!\r\n</p>\r\n"